<template>
  <default-layout>
    <h1 class="title is-h1">Create Trainer</h1>
    <form @submit.prevent="handleSubmit">
      <trainer-form @data="data = $event"></trainer-form>
      <hr>
      <div class="buttons">
        <button type="submit" class="button is-primary">Create Trainer</button>
        <button class="button is-outlined" type="button" @click="backToTrainers()">Cancel</button>
      </div>
    </form>
  </default-layout>
</template>

<script>
import TrainerForm from '../components/trainers/TrainerForm.vue'
import DefaultLayout from '../layouts/DefaultLayout.vue'
import { createTrainerMutation } from '../graphql/trainers'

export default {
  components: {
    DefaultLayout,
    TrainerForm
  },
  data () {
    return {
      data: null
    }
  },
  methods: {
    handleSubmit () {
      // submit
      this.$apollo.mutate({
        mutation: createTrainerMutation,
        variables: {
          data: this.data
        }
      })
        .then(() => {
          this.$toast.open({
            message: 'Trainer created successfully',
            type: 'is-success'
          })
          this.backToTrainers()
        })
        .catch((e) => {
          this.$toast.open({
            message: e.message || e,
            type: 'is-danger',
            duration: 5000
          })
        })
    },
    // back to trainers
    backToTrainers () {
      this.$router.push({ name: 'trainers' })
    }
  }
}
</script>
